import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useTranslation } from "react-i18next";
import TicketEventsHeader from "./TicketEventsHeader";

const DEFAULT_HOLDER_NAME = "ROB HALLSTRAND";
const DEFAULT_EVENT_LINE = "MOL 2026, Toledo, Ohio";

const BG = "#2ecc71";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    backgroundColor: BG,
    color: "#000",
    display: "flex",
    flexDirection: "column",
  },
  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(10, 2, 3),
    minHeight: 0,
  },
  centerBlock: {
    textAlign: "center",
    maxWidth: 960,
  },
  name: {
    margin: 0,
    fontFamily: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 700,
    fontSize: "clamp(1.75rem, 6vw, 3rem)",
    letterSpacing: "0.06em",
    lineHeight: 1.1,
    textTransform: "uppercase",
  },
  subline: {
    marginTop: theme.spacing(1.5),
    fontFamily: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    fontSize: "clamp(1rem, 2.75vw, 1.35rem)",
    letterSpacing: "0.02em",
  },
  infoFab: {
    position: "fixed",
    left: theme.spacing(2),
    bottom: theme.spacing(2),
    zIndex: 10,
    color: "#000",
  },
}));

function ProofOfTicket({ holderName, eventLine }) {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevH = html.style.overflowX;
    const prevB = body.style.overflowX;
    html.style.overflowX = "hidden";
    body.style.overflowX = "hidden";
    return () => {
      html.style.overflowX = prevH;
      body.style.overflowX = prevB;
    };
  }, []);

  const name = holderName ?? DEFAULT_HOLDER_NAME;
  const event = eventLine ?? DEFAULT_EVENT_LINE;

  return (
    <div className={classes.root}>
      <TicketEventsHeader variant="proof" proofSurfaceColor={BG} />

      <Box component="main" className={classes.main}>
        <div className={classes.centerBlock}>
          <Typography component="h1" className={classes.name}>
            {name}
          </Typography>
          <Typography component="p" className={classes.subline}>
            {event}
          </Typography>
        </div>
      </Box>

      <IconButton
        className={classes.infoFab}
        aria-label="More information"
        size="small"
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </div>
  );
}

export default observer(ProofOfTicket);
